import { TER01 } from "./TER01";

export const TradeTeamCoverageReport = {
  sections: [TER01],
};
